import {
  createListenerMiddleware,
  isRejectedWithValue,
} from '@reduxjs/toolkit';
import { tags } from 'core/services/consts';
import api from 'core/services/api';
import { actions } from 'core/services/authorization';
import { actions as dataActions } from 'core/services/data';
import labs from 'core/services/labs';
import grants from 'core/services/grants';
import support from 'core/services/support';

const { logout } = actions;
const { isSnackbar } = dataActions;

const createListener = (actionCreator, effect) => {
  const listener = createListenerMiddleware();
  listener.startListening({ actionCreator, effect });
  return listener.middleware;
};

const clearApiOnLogout = createListener(logout, (options, { dispatch }) => {
  dispatch(api.util.resetApiState);
  dispatch(api.util.invalidateTags([tags.ME()]));
});

const logoutOnAuthError =
  ({ dispatch }) =>
  (next) =>
  async (action) => {
    if (isRejectedWithValue(action)) {
      if (action.payload.status === 401 || action.payload.status === 403) {
        dispatch(logout());

        dispatch(
          isSnackbar({
            message: 'Your session has timed out, please login again',
            variant: 'warning',
          }),
        );
      }
    }
    return next(action);
  };

const middleware = (getDefaultMiddleware) =>
  getDefaultMiddleware({ serializableCheck: false })
    .concat(api.middleware)
    .concat(labs.middleware)
    .concat(grants.middleware)
    .concat(support.middleware)
    .concat([logoutOnAuthError, clearApiOnLogout]);

export default middleware;
